import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { useRef, useEffect, forwardRef } from 'react';
import { isFunction } from '@elliemae/ds-utilities/utils';
import DSCheckbox from '@elliemae/ds-basic/form/Checkbox';
import DSRadio from '@elliemae/ds-basic/form/Radio';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SelectableWrapper = function SelectableWrapper(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, children);
};

var SelectableComponent = /*#__PURE__*/React.memo( /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
      isMultiSelect = _ref2.isMultiSelect,
      isHeader = _ref2.isHeader,
      onSelect = _ref2.onSelect,
      isSelected = _ref2.isSelected,
      value = _ref2.value;
  var SelectComponent = isMultiSelect || isHeader ? DSCheckbox : DSRadio;
  return /*#__PURE__*/React.createElement(SelectableWrapper, {
    className: className
  }, /*#__PURE__*/React.createElement(SelectComponent, {
    checked: isSelected,
    "data-testid": "column-selectable-component",
    innerRef: ref,
    onChange: onSelect,
    tabIndex: -1,
    value: value
  }));
}, function (prev, next) {
  return next.isScrolling;
}));

var selectableFormatter = function selectableFormatter(_ref3, grid) {
  var _ref3$isMultiSelect = _ref3.isMultiSelect,
      isMultiSelect = _ref3$isMultiSelect === void 0 ? false : _ref3$isMultiSelect,
      renderer = _ref3.renderer,
      className = _ref3.className,
      isHeader = _ref3.isHeader,
      onSelect = _ref3.onSelect;
  return function (valueRender, extraParams) {
    var registerFocus = extraParams.registerFocus;
    var ref = useRef();

    var _grid$getInstance = grid.getInstance(),
        rowKey = _grid$getInstance.props.rowKey,
        selection = _grid$getInstance.state.selection,
        shiftPressed = _grid$getInstance.shiftPressed,
        lastSelectedRow = _grid$getInstance.lastSelectedRow;

    var rowData = extraParams.rowData,
        isScrolling = extraParams.isScrolling;
    useEffect(function () {
      if (registerFocus) registerFocus(ref.current);
    }, [ref.current]);
    var isSelected = isHeader ? selection.selectAll : !!selection.selectedRows[rowData[rowKey]];
    var handleSelect = isHeader ? function () {
      return onSelect(!isSelected);
    } : function () {
      return onSelect(rowData[rowKey], extraParams.rowIndex, shiftPressed, lastSelectedRow);
    };

    if (isFunction(renderer)) {
      return /*#__PURE__*/React.createElement(SelectableWrapper, {
        className: className
      }, renderer(_objectSpread(_objectSpread({
        rowData: {}
      }, extraParams), {}, {
        value: isSelected,
        isHeader: isHeader,
        onSelect: handleSelect
      })));
    }

    return /*#__PURE__*/React.createElement(SelectableComponent, {
      ref: ref,
      className: className,
      isMultiSelect: isMultiSelect,
      isScrolling: isScrolling,
      isSelected: isSelected,
      onSelect: handleSelect,
      value: !isHeader ? rowData[rowKey] : 'header-select-all'
    });
  };
};

export default selectableFormatter;
//# sourceMappingURL=selectableFormatter.js.map
